import React, { memo } from 'react';
import { Route, Switch } from 'react-router-dom';
import ExchangeFirstStep from '../ExchangeFirstStep';
import ExchangeSecondStep from '../ExchangeSecondStep';
import ExchangeTicketList from '../ExchangeTicketList';

/**
 * ExchangeRoutes component.
 * Declarative route tree for `/exchange/*`; kept mounted under ExchangeLoadingShell so parent
 * loading UI does not replace the Switch.
 * @returns {JSX.Element}
 */
const ExchangeRoutes = memo(function ExchangeRoutes() {
  return (
    <Switch>
      <Route path="/exchange/:type" exact component={ExchangeFirstStep} />
      <Route path="/exchange" exact component={ExchangeFirstStep} />
      <Route
        path="/exchange/ticket-list/:operationNumbers/:email"
        exact
        component={ExchangeTicketList}
      />
      <Route
        path="/exchange/ticket-list/:operationNumbers/:email/:document"
        exact
        component={ExchangeTicketList}
      />
      <Route
        path="/exchange/schedule/:operationNumbers/:origin/:destination"
        exact
        component={ExchangeSecondStep}
      />
      <Route
        path="/exchange/schedule/:operationNumbers/:NIT"
        exact
        component={ExchangeSecondStep}
      />
    </Switch>
  );
});

export default ExchangeRoutes;
